import { useEffect } from "react"
import {
  useAdForgeGetBrandKitQuery,
  useAdForgeProxyImageMutation,
} from "~/ui-rtk/api/adForgeApi"
import { isCustomFontFamily, registerCustomFont } from "./render-overlay"

/**
 * Loads the company's uploaded Brand Kit fonts into document.fonts. Call it
 * in any component that renders overlay content — registration is
 * module-deduped, so multiple callers cost one fetch per family. Fonts are
 * CORS-gated resources and the media bucket serves none, so the file is
 * pulled through the proxy endpoint (data: URL) before FontFace registration.
 */
export function useCustomBrandFonts(): void {
  const { data: brandKit } = useAdForgeGetBrandKitQuery()
  const [proxyImage] = useAdForgeProxyImageMutation()

  useEffect(() => {
    for (const font of brandKit?.customFonts ?? []) {
      if (!font.family || !font.url || isCustomFontFamily(font.family)) {
        continue
      }
      void proxyImage({ url: font.url })
        .unwrap()
        .then(({ base64 }) => registerCustomFont(font.family, base64))
        .catch(() => {
          // Unreachable file → fallback stack; never block rendering.
        })
    }
  }, [brandKit?.customFonts, proxyImage])
}
